"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmptyObject = isEmptyObject;
exports.isNullOrWhitespace = isNullOrWhitespace;
exports.nachweisHasEmptyTaetigkeit = nachweisHasEmptyTaetigkeit;
function isEmptyObject(obj) {
  if (obj === null || obj === undefined) {
    return true;
  }
  return Object.keys(obj).length === 0;
}
function isNullOrWhitespace(s) {
  return s === undefined || s === null || s.length === 0 || s.trim() === '';
}
function nachweisHasEmptyTaetigkeit(n, gruppe) {
  if (!n.taetigkeiten) return false;
  return n.taetigkeiten.find(function (t) {
    return isNullOrWhitespace(t.text) && t.gruppe === gruppe;
  }) !== undefined;
}